





























import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  components: {
    Swiper,
    SwiperSlide
  }
})
export default class extends Vue {
  // 接收参数
  @Prop() public data!: object[];
  public hardwareHot: any = require('@/assets/image/hardware_hot.png');

  public handleClick(item: any) {
    if (item.mode === 1) {
      window.open(item.linkUrl);
    }
  }
}
